import React from 'react';
import { NavigationCoordinates, generateNavigationUrls } from '../utils/navigationUtils';

interface NavigationIconsProps {
  coordinates: NavigationCoordinates;
  className?: string;
}

export default function NavigationIcons({ coordinates, className = '' }: NavigationIconsProps) {
  const urls = generateNavigationUrls(coordinates);

  return (
    <div className={`flex items-center space-x-1 ${className}`}>
      {/* Google Maps */}
      <a
        href={urls.googleMaps}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center w-7 h-7 bg-white border border-gray-300 rounded-full hover:bg-gray-50 hover:border-gray-400 transition-all duration-200 shadow-sm"
        title="Open in Google Maps"
      >
        <img 
          src="/google-maps.png" 
          alt="Google Maps" 
          className="w-4 h-4"
        />
      </a>

      {/* Apple Maps */}
      <a
        href={urls.appleMaps}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center w-7 h-7 bg-white border border-gray-300 rounded-full hover:bg-gray-50 hover:border-gray-400 transition-all duration-200 shadow-sm"
        title="Open in Apple Maps"
      >
        <img 
          src="/apple-maps.png" 
          alt="Apple Maps" 
          className="w-4 h-4"
        />
      </a>

      {/* Waze */}
      <a
        href={urls.waze}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center w-7 h-7 bg-white border border-gray-300 rounded-full hover:bg-gray-50 hover:border-gray-400 transition-all duration-200 shadow-sm"
        title="Open in Waze"
      >
        <img 
          src="/waze.png" 
          alt="Waze" 
          className="w-4 h-4"
        />
      </a>
    </div>
  );
}
